import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Select,
  Space,
  Table,
  Tag,
  Card,
  Switch,
  InputNumber,
  Row,
  Col,
  DatePicker,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { AiFillDelete } from "react-icons/ai";
import moment from "moment";
import "moment/locale/vi";
import locale from "antd/es/date-picker/locale/vi_VN";
import { MdOutlineAttachMoney } from "react-icons/md";
import voucherApi from "../api/voucherApi";
import Swal from "sweetalert2";
import debounce from "lodash.debounce";
import { currencyFormat } from "../utils/index";

const dataExample = {
  name: null,
  code: null,
  status: false,
  startDate: null,
  endDate: null,
  usages: null,
  value: null,
  description: null,
  Picker: null,
  conditionValue: 0,
  hasCondition: false,
};
const Voucher = (props) => {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const { Option } = Select;
  const { RangePicker } = DatePicker;

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [valueForm, setValueForm] = useState(dataExample);
  const [isEditModal, setIsEditModal] = useState(false);
  const [isEditModalShow, setIsEditModalShow] = useState(false);

  const [lstVoucher, setLstVoucher] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isShowCondition, setIsShowCondition] = useState(false);

  const [btnDeleted, setBtnDeleted] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [listDeleted, setListDeleted] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const dateFormatUTC = "DD/MM/YYYY";
  // const dateFormatOnlyDate = "YYYY/MM/DD";

  const [inputFilter, setFilter] = useState({
    name: "",
    status: null,
    sortBy: "createdAt:desc",
    page: 1,
    limit: 10,
  });

  useEffect(() => {
    getVouchers();
    form.setFieldsValue(valueForm);
  }, [inputFilter, form, valueForm]);

  const handleSearch = (e) => {
    setFilter({ ...inputFilter,page: 1, name: e.target.value });
  };

  const getVouchersDebounce = useMemo(() => debounce(handleSearch, 300), []);

  const getVouchers = () => {
    setLoading(true);

    voucherApi.getVouchers(inputFilter).then((res) => {
      if (res?.results) {
        setLstVoucher(res?.results);
        setTotalCount(res?.totalResults);
      }
      setLoading(false);
    });
  };

  const columns = [
    Table.SELECTION_COLUMN,
    {
      title: "STT",
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
      className: "text-center",
      width: "5%",
    },
    Table.EXPAND_COLUMN,
    {
      title: "Tên mã giảm giá",
      dataIndex: "name",
      render: (text) => <h3>{text}</h3>,
    },
    {
      title: "Mã giảm giá",
      dataIndex: "code",
      render: (text) => <h6>{text}</h6>,
    },
    {
      title: "Số tiền giảm",
      dataIndex: "value",
      render: (text) => <h6>{currencyFormat(text)}</h6>,
    },
    {
      title: "Giá trị đơn hàng từ",
      dataIndex: "conditionValue",
      render: (text) => <h6>{currencyFormat(text)}</h6>,
    },
    {
      title: "Số lượt sử dụng",
      dataIndex: "usages",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Số lượt còn lại",
      dataIndex: "available",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Ngày bắt đầu",
      dataIndex: "startDate",
      render: (startDate) => (
        <span>{moment(startDate).format(dateFormatUTC)}</span>
      ),
    },
    {
      title: "Ngày kết thúc",
      dataIndex: "endDate",
      render: (endDate) => <span>{moment(endDate).format(dateFormatUTC)}</span>,
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      render: (active) => (
        <>
          {active === true && (
            <Tag color="green" key={active}>
              Hoạt động
            </Tag>
          )}
          {active === false && (
            <Tag color="red" key={active}>
              Không hoạt động
            </Tag>
          )}
        </>
      ),
    },

    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => showEditModal(record)}
            value="large"
            icon={<EditOutlined />}
          >
            Sửa
          </Button>
          <Button
            value="large"
            type="primary"
            icon={<DeleteOutlined />}
            danger
            onClick={() => deleteVoucher(record)}
          >
            Xóa
          </Button>
        </Space>
      ),
      width: 150,
      className: "text-center",
      fixed: "right",
    },
  ];

  function onChange(pagination, filters, sorter, extra) {
    setPageSize(pagination.pageSize);
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }
    let sort = "createdAt:desc";
    if (sorter && sorter.columnKey) {
      let order = "ASC";
      if (sorter.order === "descend") {
        order = "DESC";
      }
      sort = sorter.columnKey + " " + order;
    }
    setFilter({
      name: inputFilter.name,
      sortBy: sort,
      limit: pagination.pageSize,
      page: pagination.current,
    });
  }

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (newSelectedRowKeys.length > 0) {
      setListDeleted(`${newSelectedRowKeys}`);
      setBtnDeleted(true);
    } else {
      setListDeleted([]);
      setBtnDeleted(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      // disabled: record.name === 'Disabled Voucher',
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const closePopup = useCallback(() => {
    setValueForm(dataExample);
    setIsShowCondition(false);
    form.resetFields();
    setIsEditModalShow(false);
  }, [form]);

  const onFinish = useCallback(
    (values) => {
      if (isEditModal) {
        updateVoucher(values);
      } else {
        createVoucher(values);
      }
    },
    [isEditModal]
  );

  const createVoucher = (data) => {
    const payload = {
      name: data.name,
      code: data.code,
      status: data.status,
      startDate: moment(data.Picker[0]),
      endDate: moment(data.Picker[1]),
      usages: data.usages,
      value: data.value,
      description: data.description,
      conditionValue: data.conditionValue ? data.conditionValue : 0,
      hasCondition: data.hasCondition,
    };
    console.log(payload);

    voucherApi.createVoucher(payload).then(
      (res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Tạo thành công",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsEditModalShow(false);
          getVouchers();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: "Tạo thất bại",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        console.log(err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const updateVoucher = (data) => {
    console.log(data.Picker);

    const payload = {
      name: data.name,
      code: data.code,
      status: data.status,
      startDate: moment(data.Picker[0]),
      endDate: moment(data.Picker[1]),
      usages: data.usages,
      value: data.value,
      description: data.description,
      conditionValue: data.conditionValue ? data.conditionValue : 0,
      hasCondition: data.hasCondition,
    };
    voucherApi.updateVoucher(data.id, payload).then(
      (res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "Sửa thành công",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsEditModalShow(false);
          getVouchers();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: "Sửa thất bại",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        console.log(err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const confirm = Modal.confirm;

  const deleteVoucher = (record) => {
    const data = {
      ids: [record.id],
    };
    confirm({
      title: "Bạn có muốn xóa voucher này không?",
      onOk() {
        voucherApi
          .deleteVoucher(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công voucher ");
              getVouchers();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const deleteVouchers = () => {
    const data = {
      ids: listDeleted,
    };
    confirm({
      title: "Bạn có muốn xóa các voucher này không?",
      onOk() {
        voucherApi
          .deleteVoucher(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công voucher ");
              getVouchers();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const showEditModal = (record) => {
    setTitleModal("Sửa mã giảm giá");
    setIsShowCondition(record.hasCondition);
    setValueForm({
      id: record.id,
      name: record.name,
      code: record.code,
      status: record.status,
      usages: record.usages,
      value: record.value,
      description: record.description,
      Picker: [moment(record.startDate), moment(record.endDate)],
      conditionValue: record.conditionValue ? record.conditionValue : 0,
      hasCondition: record.hasCondition,
    });
    setIsEditModalShow(true);
    setIsEditModal(true);
  };
  const showCreateModal = () => {
    setIsShowCondition(false);
    setTitleModal("Thêm mã giảm giá");
    setValueForm(dataExample);
    setIsEditModalShow(true);
    setIsEditModal(false);
  };

  const hasCondition = (value) => {
    setIsShowCondition(value);
  };
  return (
    <>
      <div className="tabled">
        <Card>
          <Row gutter={16}>
            <Col span={6}>
              <label> Tên mã giảm giá</label>
              <br />
              <Input
                addonAfter={<SearchOutlined />}
                // value={inputFilter.Vouchername}
                placeholder="Nhập tên ..."
                onChange={getVouchersDebounce}
                style={{
                  width: "100%",
                }}
              />
            </Col>

            <Col span={6}>
              <label> Trạng thái</label>
              <Select
                value={inputFilter.status}
                placeholder="Chọn để tìm kiếm..."
                size="large"
                style={{
                  width: "100%",
                }}
                defaultValue=""
                onChange={(e) => {
                  setFilter({ ...inputFilter, page: 1,status: e });
                }}
              >
                <Option value="">--- Mặc định ---</Option>
                <Option value="true">Hoạt động</Option>
                <Option value="false">Không hoạt động</Option>
              </Select>
            </Col>
            <Col span={6}></Col>
          </Row>
        </Card>
        <br />
        <br />
        <Space size={10}>
          <Button type="dashed" size="small" onClick={() => showCreateModal()}>
            <EditOutlined /> &nbsp; Thêm mã giảm giá
          </Button>

          {btnDeleted ? (
            <Button
              value="small"
              type="primary"
              icon={<AiFillDelete />}
              danger
              onClick={() => {
                deleteVouchers();
              }}
            >
              &nbsp; Xóa các mục được chọn
            </Button>
          ) : null}
        </Space>
        <br />
        <br />
        <Card bordered={true} className="criclebox tablespace mt-10 mb-24">
          <div className="table-responsive">
            <Table
              rowSelection={{
                ...rowSelection,
              }}
              rowKey={(record) => record.id.toString()}
              loading={loading}
              onChange={onChange}
              columns={columns}
              dataSource={lstVoucher}
              bordered
              className="ant-border-space"
              pagination={{
                pageSize: pageSize,
                total: totalCount,
                pageSizeOptions: ["10", "50", "100", "200"],
              }}
              expandable={{
                expandedRowRender: (record) => (
                  <p
                    style={{
                      margin: 0,
                    }}
                  >
                    <b> Mô tả</b> : {record.description}
                  </p>
                ),
              }}
            />
          </div>
        </Card>
      </div>

      <Modal
        title={titleModal}
        visible={isEditModalShow}
        onOk={form.submit}
        onCancel={() => {
          closePopup();
        }}
        style={{
          top: 25,
        }}
      >
        <div>
          <Form
            initialValues={valueForm}
            form={form}
            name="basic"
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item hidden={true} label="Id" name="id">
              <Input />
            </Form.Item>

            <Form.Item
              label="Tên mã giảm giá"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập tên!",
                },
              ]}
            >
              <Input placeholder="Nhập tên ..." />
            </Form.Item>

            <Form.Item
              label="Mã giảm giá"
              name="code"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập code!",
                },
              ]}
            >
              {isEditModal ? (
                <Input disabled />
              ) : (
                <Input placeholder="Nhập code ..." />
              )}
            </Form.Item>

            <Form.Item
              label="Số tiền giảm"
              name="value"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập số tiền được giảm!",
                },
              ]}
            >
              <InputNumber
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                addonAfter={<MdOutlineAttachMoney />}
              />
            </Form.Item>

            <Row gutter={[24, 24]}>
              <Col span={[12, 12]}>
                <Form.Item
                  label="Điều kiện giảm"
                  name="hasCondition"
                  valuePropName="checked"
                >
                  <Switch onChange={hasCondition} />
                </Form.Item>
              </Col>
              <Col>
                {isShowCondition ? (
                  <>
                    <Form.Item
                      label="Giá trị đơn hàng từ"
                      name="conditionValue"
                      rules={[
                        {
                          required: true,
                          message: "Vui lòng nhập !",
                        },
                      ]}
                    >
                      <InputNumber
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                        parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                        addonAfter={<MdOutlineAttachMoney />}
                      />
                    </Form.Item>
                  </>
                ) : null}
              </Col>
            </Row>
            <Form.Item
              label="Số lượt sử dụng"
              name="usages"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập !",
                },
              ]}
            >
              <InputNumber min={0} />
            </Form.Item>
            <Form.Item
              label="Ngày bắt đầu và kết thúc"
              name="Picker"
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn ngày !",
                },
              ]}
            >
              <RangePicker locale={locale} format={dateFormatUTC} />
            </Form.Item>
            <Form.Item label="Mô tả" name="description">
              <TextArea rows={3} />
            </Form.Item>
            <Form.Item label="Trạng thái" valuePropName="checked" name="status">
              <Switch />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default Voucher;
